export default function syncableEndnoteChangeDirective() {
  return {
    template: require('./syncable-endnote-change.html'),
    restrict: 'E',
    controller: 'SyncableEndnoteChangeController',
    controllerAs: 'syncableEndnoteChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
    },
  };
}
